import React from 'react'
import { Route } from 'react-router'
import * as Views from './views'

const Routes = <Route path="partners/:id" component={Views.Partner} />

export default Routes
